import axios from "axios";
import {getConfig} from "../config";

const { KI_AGENT_BASE_URL } = getConfig();

export type AgentRunResponse = any;

// Eigene, isolierte axios-Instanz ohne globale Defaults/Custom-Header:
const http = axios.create({
    baseURL: KI_AGENT_BASE_URL,
    withCredentials: false,
    headers: {
        "Content-Type": "application/json",
    },
    transformRequest: [(data) => JSON.stringify(data)],
});

export async function runAgent({
                                   sessionId,
                                   projectNo,
                                   message,
                                   extras,
                               }: {
    sessionId: string;
    projectNo?: string;
    message: string;
    extras?: Record<string, unknown>;
}): Promise<AgentRunResponse> {
    const payload: any = {
        conversation_id: sessionId,
        input_as_text: message,
    };
    if (projectNo) {
        payload.context = { projectNo };
    }
    if (extras && Object.keys(extras).length > 0) {
        payload.extras = extras;
    }
    const { data } = await http.post("/run", payload, {
        responseType: "text",
    });
    try {
        if (typeof data === "string" && data.trim().startsWith("{")) {
            return JSON.parse(data);
        }
    } catch {
        console.log("Error parsing JSON response:", data);
    }
    return data;
}
